// //скрипт для select
$('.select-wrap input.visible').on('click', function() {
	$(this).parent('.visible-arrow').addClass('active');
	$('.select-option').removeClass('active');
	$(this).parents('.select-wrap').find('.select-option').addClass('active');
});
// $('.select-wrap .select-option li').on('click', function() {
// 	$(this).parents('.select-wrap').find('input.visible').val($(this).text());
// 	$(this).parents('.select-wrap').find('input.disabled').val($(this).text());
// 	$(this).parents('.select-wrap').find('input.disabled').attr('name', $(this).attr('data-name'));
// 	$(this).parents('.select-wrapper').find('input').trigger('blur');
// 	$(this).parents('.select-wrap').find('input').trigger('change');
// 	$(this).parent('.select-option').removeClass('active');
// 	$(this).parents('.select-wrap').find('.visible-arrow').removeClass('active');
// 	// console.log($(this).parents('.select-wrap').find('input'));
// });
// //если клик не по селект закрыть его
// //красивый скроллбар

//



// WEBPACK FOOTER //
// ./libs/castomSelect.js